import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import RecetaMedica from '../../components/admin/RecetaMedica';

// Import our animations CSS
import '../../styles/animations.css';

const GenerarRecetaPage = () => {
  const { pacienteId } = useParams();
  const navigate = useNavigate();
  const [paciente, setPaciente] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading patient data
    const cargarPaciente = async () => {
      try {
        setLoading(true);
        
        // If we have a real API call, we'd use it here
        // const response = await pacienteService.getPacienteById(pacienteId);
        
        // For demo, we'll simulate a delay and create dummy data
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Dummy patient data
        setPaciente({
          id: pacienteId || '123',
          nombre: 'Juan',
          apellido: 'Pérez',
          cedula: '1234567890',
          email: 'juan.perez@example.com',
          telefono: '0987654321'
        });
      } catch (error) {
        console.error('Error al cargar datos del paciente:', error);
        toast.error('No se pudo cargar la información del paciente');
      } finally {
        setLoading(false);
      }
    };

    cargarPaciente();
  }, [pacienteId]);

  const handleCancel = () => {
    navigate('/dashboard/pacientes');
  };

  // Función para agendar una nueva cita
  const handleAgendarCita = async (citaData) => {
    try {
      // Aquí iría la llamada real a la API para agendar la cita
      // Por ahora simulamos la operación
      console.log('Agendando cita con datos:', citaData);
      
      // Simular una demora de red
      await new Promise(resolve => setTimeout(resolve, 800));
      
      // Simulamos éxito
      toast.success(`Cita agendada para ${citaData.fecha} a las ${citaData.hora}`);
      return Promise.resolve({ success: true });
    } catch (error) {
      console.error('Error al agendar cita:', error);
      toast.error('No se pudo agendar la cita');
      return Promise.reject(error);
    }
  };

  return (
    <div className="container px-4 py-6">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 border-t-2 border-b-2 border-blue-500 rounded-full spin"></div>
              <p className="mt-4 text-gray-600">Cargando información...</p>
            </div>
          </div>
        ) : (
          <div className="max-w-4xl mx-auto">
            {paciente ? (
              <RecetaMedica
                paciente={paciente}
                proximaCita=""
                diagnostico=""
                doctorNombre="Dra. Ximena Ríos R."
                onCancel={handleCancel}
                onAgendarCita={handleAgendarCita}
              />
            ) : (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                <p>No se encontró información del paciente. Por favor, intente nuevamente.</p>
              </div>
            )}
          </div>
        )}
      </div>
  );
};

export default GenerarRecetaPage;